/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useCallback, useEffect, useState } from "react"
import PropTypes from "prop-types"

import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { useBrowserLayout } from "@src/utils/hooks/layout"
import classnames from "@src/utils/classnames"
import { requestCurrentUser } from "@src/utils/request"
import { navigate } from "gatsby"
import { wxConfig, wxShare } from "@src/utils/wechat"

const notNeedLoginPaths = ["welcome", "test"]

const checkNeedLogin = (pathname) => {
  for (const path of notNeedLoginPaths) {
    if (pathname.includes(path)) {
      return false
    }
  }

  return true
}

const Layout = ({ children, location }) => {
  const [currentUser, setCurrentUser] = useState()
  const [isLoading, setIsLoading] = useState()
  const { isWXBrowser, isGcoresApp, md } = useBrowserLayout()

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  useEffect(() => {
    const getUser = async () => {
      const user = await requestCurrentUser()
      setCurrentUser(user)
      if (!user && checkNeedLogin(location.pathname)) {
        navigate("/welcome")
      }
    }

    void getUser()
  }, [])

  const body = (() => {
    if (currentUser === undefined) {
      return null
    }

    if (currentUser === null && checkNeedLogin(location.pathname)) {
      return null
    }

    return children
  })()

  const setLoading = useCallback((on) => {
    setIsLoading(on)
  }, [])

  return (
    <AppContext.Provider
      value={{
        isGcoresApp,
        isWXBrowser,
        currentUser,
        setLoading,
        md,
      }}
    >
      <Seo />
      <div style={{ fontFamily: "Rubik", textIndent: "-9999px", height: 0 }}>
        load font
      </div>
      {/* <Nav location={location} /> */}
      <div className={styles.mobileLayoutFullscreen}>
        <div
          className={classnames(styles.mobileLayoutContainer, styles.isReady)}
        >
          <div
            className={classnames(styles.loading, {
              [styles.isLoading]: isLoading,
            })}
          >
            Loading...
          </div>
          {body}
        </div>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
